import type { BulkAction } from "@/components/shared/UniversalCRMTable/types";
import type { DetailAction } from "@/components/shared/UniversalDetailPage/types/detailPage";
import type { Offering } from "@/lib/types/database/offerings";

export const offeringActions = {
  view: true,
  edit: true,
  delete: true,
};

export const offeringDetailActions: DetailAction<Offering>[] = [
  {
    id: "view-details",
    label: "View Details",
    icon: "eye",
    variant: "outline",
    primary: false,
    action: "viewOffering",
    allowedRoles: ["wtc_admin", "wtc_crm", "wtc_employee"],
  },
  {
    id: "download-pdf",
    label: "Download PDF",
    icon: "download",
    variant: "outline",
    primary: true,
    action: "downloadOfferingPdf",
    allowedRoles: ["wtc_admin", "wtc_crm", "wtc_employee"],
    tooltip: "Download offering as PDF to share with client",
  },
  {
    id: "convert-to-deal",
    label: "Convert to Deal",
    icon: "trending-up",
    variant: "outline",
    primary: false,
    action: "convertToDeal",
    allowedRoles: ["wtc_admin", "wtc_crm", "wtc_employee"],
    tooltip: "Create a deal from this offering — assign to a company and fill in details",
  },
  {
    id: "ask-meridian",
    label: "Ask Meridian",
    icon: "meridian",
    variant: "outline",
    action: "askMeridian",
    tooltip: "Ask Meridian AI assistant about this offering",
    allowedRoles: ["wtc_admin", "wtc_crm", "wtc_employee"],
  },
  {
    id: "edit",
    label: "Edit",
    icon: "edit",
    variant: "outline",
    action: "openEditModal",
    allowedRoles: ["wtc_admin", "wtc_crm"],
  },
  {
    id: "delete",
    label: "Delete",
    icon: "trash",
    variant: "destructive",
    action: "deleteItem",
    allowedRoles: ["wtc_admin"],
    bulkable: true,
  },
];

export const offeringBulkActions: BulkAction<Offering>[] = [
  {
    id: "bulk_export",
    label: "Export",
    icon: "Download",
  },
];
